import React from 'react';
import {
  Box,
  Button,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { useToast } from '@chakra-ui/react';
import { useCancelScheduleMutation } from '@spartalabs/pdc-core';

interface CancelModalProps {
  isOpen: boolean;
  onClose: (isCancel?: boolean) => void;
  id: string;
  obj?: TableScheduleData;
}

export const CancelModal = ({ isOpen, onClose, id, obj }: CancelModalProps) => {
  const toast = useToast();
  const [cancelSchedule, { isLoading: IsLoadingMutation }] =
    useCancelScheduleMutation();

  const objFiltered = obj ? obj.itens.filter(item => item.id === id) : [];

  const handleCancelSchedule = async () => {
    try {
      await cancelSchedule(objFiltered[0]).unwrap();

      toast({
        position: 'top',
        title: 'Agendamento cancelado com sucesso',
        description: 'O agendamento foi cancelado com sucesso',
        status: 'success',
        duration: 9000,
        isClosable: true,
      });
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      toast({
        position: 'top',
        title: 'Erro ao cancelar o agendamento',
        description: 'Ocorreu um erro ao cancelar o agendamento',
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
    }
    onClose(true);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text fontSize="20px" color="black">
            Confirmar a solicitação de cancelamento
          </Text>
        </ModalHeader>
        <ModalBody>
          <Flex gap="18px">
            <Box w="full" display="flex" flexDir="column">
              <Text color="text.300" fontSize="14px" as="label">
                Placa do Veículo
              </Text>
              <Input
                readOnly
                bg="gray.200"
                border="1px solid"
                borderColor="gray.100"
                value={id}
              />
            </Box>
            <Box w="full" display="flex" flexDir="column">
              <Text color="text.300" fontSize="14px" as="label">
                N.º de atendimento
              </Text>
              <Input
                readOnly
                bg="gray.200"
                border="1px solid"
                borderColor="gray.100"
                value={objFiltered ? objFiltered[0]?.plate : '-'}
              />
            </Box>
          </Flex>
        </ModalBody>

        <ModalFooter>
          <Button variant="outline" mr={3} onClick={() => onClose()}>
            Voltar
          </Button>
          <Button isLoading={IsLoadingMutation} onClick={handleCancelSchedule}>
            Confirmar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
